<div *ngIf="isPageReady" class="flex flex-col h-full">
  <div class="qb-content-card flex-1">
    <div class="qb-detail-card w-full h-fit">
      <div class="flex flex-col gap-3">
        <!-- Row 1: Name -->
        <div class="grid grid-cols-12 gap-3">
          <qb-field label="Name" class="col-span-12">
            <input #firstInput [(ngModel)]="boxSize.name" [bzModel]="boxSize" name="name" pInputText title="Name" />
          </qb-field>
        </div>
        <!-- Row 2: Length + Width + Height -->
        <div class="grid grid-cols-12 gap-3">
          <qb-field label="Length (in)" class="col-span-4">
            <p-inputNumber [(ngModel)]="boxSize.length" [bzModel]="boxSize" name="length"
              [minFractionDigits]="0" [maxFractionDigits]="2" />
          </qb-field>
          <qb-field label="Width (in)" class="col-span-4">
            <p-inputNumber [(ngModel)]="boxSize.width" [bzModel]="boxSize" name="width"
              [minFractionDigits]="0" [maxFractionDigits]="2" />
          </qb-field>
          <qb-field label="Height (in)" class="col-span-4">
            <p-inputNumber [(ngModel)]="boxSize.height" [bzModel]="boxSize" name="height"
              [minFractionDigits]="0" [maxFractionDigits]="2" />
          </qb-field>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-row gap-2 justify-start mt-4">
    <button (click)="ok()" pButton type="button" class="p-button-raised" icon="pi pi-check">
      <span>Ok</span>
    </button>
    <button (click)="cancel()" pButton type="button" class="p-button-raised" icon="pi pi-times">
      <span>Cancel</span>
    </button>
  </div>
</div>
